function mhProducts(){
    $('.product').each(function(){
        $(this).find('.p').prepend('<a href="'+$(this).find('a.image').attr('href')+'" class="absoluteLink"></a>')
        if($(this).find('.flag-discount').length){
            $(this).find('.prices').prepend($(this).find('.price-standard'))
        }
        var dataNext = $(this).find('a.image img').attr('data-next')
        $(this).find('a.image img').attr('data-src', $(this).find('a.image img').attr('data-src').replace('/detail/', '/orig/'))
        $(this).find('a.image img').attr('data-next', dataNext.replace('/detail/', '/orig/'))
    })
}


$(document).ready(function() {
    mhProducts()
  })
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    mhProducts()
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    mhProducts();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    mhProducts();
});